// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SyncOutlined from '/home/jack/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/SyncOutlined';
import CloudUploadOutlined from '/home/jack/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/CloudUploadOutlined';
import SettingOutlined from '/home/jack/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SyncOutlined, CloudUploadOutlined, SettingOutlined };
